export enum RenderOrder {
  Default = 0,
  Water,
  PropertyEntity,
  UnitEntity,
  RoadEntity,
  MapGridBorderWalls,
  SelectedPositionTileCursor,
}
